const PRODUCTION = 'production'
const DEVELOPMENT = 'development'

const env = process.env.NODE_ENV || DEVELOPMENT

const api = 'https://api.todayme.ru/api'
const domen = {
  isUnipro: false,
  isTele2: false,
  isAlfa: false
}

const host = env === PRODUCTION
  ? 'https://lk.todayme.ru'
  : 'https://lk.todayme.ru'//'https://localhost:3000'

export { api, host, domen}



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/config.js